import { createContext, ReactChildren, ReactFragment, ReactPortal, useContext, useState } from 'react'

type ScenesContextType = {
  currentSceneIdx: number
  setCurrentSceneIdx: (val: number) => void
}

export const ScenesContext = createContext<ScenesContextType>({
  currentSceneIdx: 0,
  setCurrentSceneIdx: (val: number) => {},
})

const ScenesProvider = ({ children }: { children: ReactChildren | ReactFragment | ReactPortal }) => {
  // @TODO improve scene selection by key/name instead of position in the array of Canvas children
  const [currentSceneIdx, setCurrentSceneIdx] = useState<number>(0)

  return <ScenesContext.Provider value={{ currentSceneIdx, setCurrentSceneIdx }}>{children}</ScenesContext.Provider>
}

export default ScenesProvider
